import React from 'react';

import { styles } from '../Button/styled-components';
import Button from '../Button/Button';

import { ButtonBar } from './styled-components';

/**
 * @param {array} buttons - butttons expects an array of button objects which are getting mapped
 * as single buttons
 * @param {enum: } buttonStyle - describes the outer appearance of the buttons
 */
const Buttons = ({buttons, buttonStyle}) =>
  <ButtonBar>{buttons.map(button => <Button {...button} animation={false} buttonStyle={buttonStyle}>{button.title}</Button>)}</ButtonBar>

Buttons.defaultProps = {
  buttonStyle: styles.RED,
  buttons: [{
    title: 'Lorem Ipsum',
    url: 'http://google.com',
  }]
}

export default Buttons;